import TIM from 'tim-js-sdk'

export default {
  loginIM,
  logout,
  applyJoinBigGroup,
  quitBigGroup,
  loginAndJoinGroup,
  configIM,
  setMsgListener,
  onSendTextMsg,
  sendApplyLink,
  sendSureLink,
  sendRefuseLink,
  sendCannotLink,
  setImStatusListener,
  setMemberMsgListener,
  sendTextMsg,
  onSendP2PMsg,
  getNotification,
  studentOneKeyLinkMic
}

// 当前用户身份
var loginInfo = {
  identifier: 0, // 当前用户ID,必须是否字符串类型，选填
  identifierNick: '', // 当前用户昵称，选填
  userSig: '', // 当前用户身份凭证，必须是字符串类型，选填
  headurl: '' // 当前用户默认头像，选填
}

var currentGroupId = ''
var tim = null

var memberMsgListener
function setMemberMsgListener (cb) {
  memberMsgListener = cb
}

var imStatusListener
function setImStatusListener (cb) {
  imStatusListener = cb
}

var normalCallBack // 普通消息回调，在互动页面显示的消息为普通消息
function setMsgListener (cb) {
  normalCallBack = cb
}

// 配置IM
function configIM (data) {
  currentGroupId = data.currentGroupId;
  loginInfo.identifier = data.identifier;
  loginInfo.identifierNick = data.identifierNick;
  loginInfo.headurl = data.headurl;
  loginInfo.userSig = data.userSig;
  tim = TIM.create({SDKAppID: 1400058601})
  tim.setLogLevel(0)
  // 监听事件，如：
  tim.on(TIM.EVENT.SDK_READY, function (event) {
    console.log('TIM.EVENT.SDK_READY')
    let promise = tim.updateMyProfile({
      nick: loginInfo.identifierNick
    })
    promise.then(function (imResponse) {
      console.log('更新资料成功', imResponse.data) // 更新资料成功
    }).catch(function (imError) {
      console.warn('updateMyProfile error:', imError) // 更新资料失败的相关信息
    })
  })

  tim.on(TIM.EVENT.NET_STATE_CHANGE, function (event) {
    // 网络状态发生改变（v2.5.0 起支持）
    // event.name - TIM.EVENT.NET_STATE_CHANGE
    // event.data.state 当前网络状态，枚举值及说明如下：
    //   - TIM.TYPES.NET_STATE_CONNECTED - 已接入网络
    //   - TIM.TYPES.NET_STATE_CONNECTING - 连接中。很可能遇到网络抖动，SDK 在重试。接入侧可根据此状态提示“当前网络不稳定”或“连接中”
    //   - TIM.TYPES.NET_STATE_DISCONNECTED - 未接入网络。接入侧可根据此状态提示“当前网络不可用”。SDK 仍会继续重试，若用户网络恢复，SDK 会自动同步消息
    console.log('TIM.EVENT.NET_STATE_CHANGE', event)
    if (imStatusListener) {
      if (event.data.state === TIM.TYPES.NET_STATE_CONNECTED) {
        imStatusListener({ErrorCode: 1})
      } else if (event.data.state === TIM.TYPES.NET_STATE_CONNECTING) {
        // imStatusListener({ErrorCode: 1})
      } else if (event.data.state === TIM.TYPES.NET_STATE_DISCONNECTED) {
        imStatusListener({ErrorCode: 9999})
      }
    }
  })

  tim.on(TIM.EVENT.MESSAGE_RECEIVED, function (event) {
    // 收到推送的单聊、群聊、群提示、群系统通知的新消息，可通过遍历 event.data 获取消息列表数据并渲染到页面
    // event.name - TIM.EVENT.MESSAGE_RECEIVED
    // event.data - 存储 Message 对象的数组 - [Message]
    // console.log('TIM.EVENT.MESSAGE_RECEIVED', event)
    for (let index = 0; index < event.data.length; index++) {
      const element = event.data[index]
        let text = element.payload.text
        let msgData = null
        if (text) {
          text = text.replace(/&quot;/g, '"')
          msgData = JSON.parse(text)
        }
        if (element.conversationType === TIM.TYPES.CONV_C2C) { // 1V1消息
          if (msgData) {
            memberMsgListener && memberMsgListener(msgData)
          }
        } else if (element.conversationType === TIM.TYPES.CONV_GROUP && currentGroupId == element.to) { // 群消息
            if (element.type === 'TIMGroupTipElem') { // 群信息修改提示
              let groupProfile = element.payload.newGroupProfile
              if (groupProfile) {
                if (groupProfile.introduction && groupProfile.introduction!="{}") {
                  normalCallBack && normalCallBack({
                    module: 'system_message_group_introduction',
                    content: JSON.parse(groupProfile.introduction) || {}
                  })
                }
                if (groupProfile.notification) {
                  normalCallBack && normalCallBack({
                    module: 'system_message_group_notification',
                    content: JSON.parse(groupProfile.notification) || {}
                  })
                }
              }
            } else if(element.type === 'TIMCustomElem'){
               if (element.payload.extension == "TXWhiteBoardExt") {
                  normalCallBack && normalCallBack({
                    module: 'TXWhiteBoardExt',
                    content: element.payload.data
                  })
               }
            }else { 
              if (msgData) {
                normalCallBack && normalCallBack(msgData)
              }
            }  
        }
    }
  })
}

function loginAndJoinGroup (callBack) {
  console.log("调了几次")
  // 这里需要获取IM数据
  loginIM(function (isSuccess) {
    if (isSuccess) {
      // 登入成功了
      applyJoinBigGroup(callBack)
    } else {
      // 登入失败了
      callBack(false)
    }
  })
}

// 登录方法
function loginIM (callBack) {
  console.log('登录方法')
  // 开始登录
  tim.login({userID: `${loginInfo.identifier}`, userSig: loginInfo.userSig}).then(function (imResponse) {
    console.log('开始登录', imResponse.data)
    callBack(true)
  }).catch(function (imError) {
    callBack(false)
    console.warn('login error:', imError) // 登录失败的相关信息
  })
}
// 登出
function logout (callBack) {
  if (tim) {
    tim.logout().then(res => {
      callBack(true)
    }).catch(imError => {
      callBack(true)
    })
  }
}

// 进入大群
function applyJoinBigGroup (callBack) {
  console.log('进入大群____applyJoinBigGroup')
  const promise = tim.joinGroup({ groupID: currentGroupId, type: TIM.TYPES.GRP_AVCHATROOM })
  promise.then((imResponse) => {
    console.log('加入群聊回调', imResponse)
    switch (imResponse.data.status) {
      case TIM.TYPES.JOIN_STATUS_WAIT_APPROVAL:
        break // 等待管理员同意
      case TIM.TYPES.JOIN_STATUS_SUCCESS: // 加群成功
        console.log(imResponse.data.group) // 加入的群组资料
        console.log('加入群聊成功')
        callBack(true)
        let groupInfo = imResponse.data.group
        if (groupInfo && groupInfo.introduction && groupInfo.introduction!="{}") {
          normalCallBack && normalCallBack({
            module: 'system_message_group_introduction',
            content: JSON.parse(groupInfo.introduction) || {}
          })
        }
        if (groupInfo && groupInfo.notification && groupInfo.notification!="{}") {
          normalCallBack && normalCallBack({
            module: 'system_message_group_notification',
            content: JSON.parse(groupInfo.notification) || {}
          })
        }
        break
      case TIM.TYPES.JOIN_STATUS_ALREADY_IN_GROUP: // 已经在群中
        console.log(imResponse.data.group) // 加入的群组资料
        console.log('加入群聊成功')
        callBack(true)
        let groupInfo2 = imResponse.data.group
        if (groupInfo2 && groupInfo2.introduction) {
          normalCallBack && normalCallBack({
            module: 'system_message_group_introduction',
            content: JSON.parse(groupInfo2.introduction)
          })
        }
        if (groupInfo2 && groupInfo2.notification) {
          normalCallBack && normalCallBack({
            module: 'system_message_group_notification',
            content: JSON.parse(groupInfo2.notification)
          })
        }
        break
      default: break
    }
  }).catch(function (imError) {
    callBack(false)
    console.warn('joinGroup error:', imError) // 申请加群失败的相关信息
  })
}

// 申请连麦
function sendApplyLink () {
  var date1 = new Date()
  var timestamp = Date.parse(date1)
  var time = date1.pattern('MM-dd hh:mm')
  var obj = {}
  obj.nick = loginInfo.identifierNick
  obj.header_url = loginInfo.headurl
  obj.fans_id = loginInfo.identifier
  obj.time = time
  obj.msgid = timestamp
  obj.module = 'applyLink'

  var text = JSON.stringify(obj)
  onSendMsg(text)
}

// 接收老师邀请，确认上麦
function sendSureLink () {
  var date1 = new Date()
  var timestamp = Date.parse(date1)
  var time = date1.pattern('MM-dd hh:mm')
  var obj = {}
  obj.nick = loginInfo.identifierNick
  obj.header_url = loginInfo.headurl
  obj.fans_id = loginInfo.identifier
  obj.time = time
  obj.msgid = timestamp
  obj.module = 'sureLink'
  var text = JSON.stringify(obj)
  onSendMsg(text)
}

// 学生一键连麦
function studentOneKeyLinkMic () {
  var date1 = new Date()
  var timestamp = Date.parse(date1)
  var time = date1.pattern('MM-dd hh:mm')
  var obj = {}
  obj.nick = loginInfo.identifierNick
  obj.header_url = loginInfo.headurl
  obj.fans_id = loginInfo.identifier
  obj.time = time
  obj.msgid = timestamp
  obj.student_onekey_linkMic = 1
  obj.module = 'applyLink'
  var text = JSON.stringify(obj)
  onSendMsg(text)
}

// 接收老师邀请，拒绝上麦
function sendRefuseLink () {
  var date1 = new Date()
  var timestamp = Date.parse(date1)
  var time = date1.pattern('MM-dd hh:mm')
  var obj = {}
  obj.nick = loginInfo.identifierNick
  obj.header_url = loginInfo.headurl
  obj.fans_id = loginInfo.identifier
  obj.time = time
  obj.msgid = timestamp
  obj.module = 'refuseLink'
  var text = JSON.stringify(obj)
  onSendMsg(text)
}

function sendTextMsg (msg) {
  var text = JSON.stringify(msg)
  onSendMsg(text)
}

// 当前设备不支持连麦
function sendCannotLink (content) {
  var date1 = new Date()
  var timestamp = Date.parse(date1)
  var time = date1.pattern('MM-dd hh:mm')
  var obj = {}
  obj.nick = loginInfo.identifierNick
  obj.header_url = loginInfo.headurl
  obj.fans_id = loginInfo.identifier
  obj.time = time
  obj.msgid = timestamp
  obj.module = 'cannotLink'
  obj.content = content
  var text = JSON.stringify(obj)
  onSendMsg(text)
}

// 退出大群
function quitBigGroup () {
  let promise = tim.quitGroup(currentGroupId + '')
  promise.then(function (imResponse) {
    console.log(imResponse.data.groupID) // 退出成功的群 ID
  }).catch(function (imError) {
    console.warn('quitGroup error:', imError) // 退出群组失败的相关信息
  })
}

function onSendP2PMsg (text, userId) {
  console.log('发送私聊消息')
  // 发送文本消息，Web 端与小程序端相同
  // 1. 创建消息实例，接口返回的实例可以上屏
  if (tim) {
    let message = tim.createTextMessage({
      to: userId + '',
      conversationType: TIM.TYPES.CONV_C2C,
      // 消息优先级，用于群聊（v2.4.2起支持）。如果某个群的消息超过了频率限制，后台会优先下发高优先级的消息，详细请参考：https://cloud.tencent.com/document/product/269/3663#.E6.B6.88.E6.81.AF.E4.BC.98.E5.85.88.E7.BA.A7.E4.B8.8E.E9.A2.91.E7.8E.87.E6.8E.A7.E5.88.B6)
      // 支持的枚举值：TIM.TYPES.MSG_PRIORITY_HIGH, TIM.TYPES.MSG_PRIORITY_NORMAL（默认）, TIM.TYPES.MSG_PRIORITY_LOW, TIM.TYPES.MSG_PRIORITY_LOWEST
      // priority: TIM.TYPES.MSG_PRIORITY_NORMAL,
      payload: {
        text: text
      }
    // 消息自定义数据（云端保存，会发送到对端，程序卸载重装后还能拉取到，v2.10.2起支持）
    // cloudCustomData: 'your cloud custom data'
    })
    // 2. 发送消息
    let promise = tim.sendMessage(message)
    promise.then(function (imResponse) {
    // 发送成功
      console.log('发送成功')
    }).catch(function (imError) {
    // 发送失败
      console.warn('sendMessage error:', imError)
    })
  }
}

// eslint-disable-next-line no-extend-native
Date.prototype.pattern = function (fmt) {
  var o = {
    'M+': this.getMonth() + 1, // 月份
    'd+': this.getDate(), // 日
    'h+': this.getHours() % 12 === 0 ? 12 : this.getHours() % 12, // 小时
    'H+': this.getHours(), // 小时
    'm+': this.getMinutes(), // 分
    's+': this.getSeconds(), // 秒
    'q+': Math.floor((this.getMonth() + 3) / 3), // 季度
    S: this.getMilliseconds() // 毫秒
  }
  var week = {
    '0': '/u65e5',
    '1': '/u4e00',
    '2': '/u4e8c',
    '3': '/u4e09',
    '4': '/u56db',
    '5': '/u4e94',
    '6': '/u516d'
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (this.getFullYear() + '').substr(4 - RegExp.$1.length)
    )
  }
  if (/(E+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (RegExp.$1.length > 1
        ? RegExp.$1.length > 2
          ? '/u661f/u671f'
          : '/u5468'
        : '') + week[this.getDay() + '']
    )
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
      )
    }
  }
  return fmt
}

// 发送普通IM消息
function onSendTextMsg (text, type) {
  // 获取消息内容

  if (text.length < 1) {
    alert('发送的消息不能为空!')
    return
  }

  var date1 = new Date()
  var timestamp = Date.parse(date1)
  var time = date1.pattern('MM-dd hh:mm')

  var obj = {}

  obj.nick = loginInfo.identifierNick
  obj.header_url = loginInfo.headurl
  obj.fans_id = loginInfo.identifier
  obj.conent = text
  obj.like_num = 0
  obj.time = time
  obj.msgid = timestamp

  if (type === 1) {
    obj.module = 'enterPerson'
  }

  // eslint-disable-next-line no-redeclare
  var text = JSON.stringify(obj)
  onSendMsg(text)
}

// 发送IM消息
function onSendMsg (text) {
  if (tim) {
    const message = tim.createTextMessage({
      to: currentGroupId + '',
      conversationType: TIM.TYPES.CONV_GROUP, // 群组会话
      payload: {
        text: text
      }
    })
    tim.sendMessage(message).then((imResponse) => {
      // 发送成功
      console.log('发送成功')
    }).catch((imError) => {
      // 发送失败
      console.log('发送失败')
    })
  }
}

//获取群公告
function getNotification(callBack) {
  var data = {};
  //静态秘钥写死，不需要网络获取秘钥
  data.Notification = "1111110111";
  callBack(data);
  return;
}
